import { SettingsService } from '@pepperhq/settings-sdk';
import { HttpClient } from 'components/http/HttpClient';
import logger from 'lib/logger';
import { TenantData } from './model/Settings';

class SettingsApi extends HttpClient {
    constructor() {
        super({
            baseURL: process.env.TENANT_SERVICE_URL,
            url: ''
        });
    }
    public async getTenant(merchantId: string): Promise<TenantData> {
        return this.getRequest({
            url: `/tenants/${merchantId}`,
            headerConfigs: { shouldIncludeAuthToken: false, shouldIncludeXApplicationId: false }
        });
    }

    public getSettings(merchantId: string, locationId?: string): Promise<any> {
        return new SettingsService(process.env.SETTINGS_SERVICE_URL).getPublicSettings(
            {
                logger,
                session: { tenantId: merchantId }
            },
            locationId
        );
    }
}

export const settingsApi = new SettingsApi();
